import { render, staticRenderFns } from "./mpTest.vue?vue&type=template&id=ca9446f6&scoped=true&"
import script from "./mpTest.vue?vue&type=script&lang=js&"
export * from "./mpTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9446f6",
  null
  
)

export default component.exports